import entries from './guide-entries.json';

const articles = import.meta.glob<string>('../docs/content/articles/*.md', {
  query: '?raw',
  import: 'default',
  eager: true
});

export const guides = entries.map((entry) => {
  const markdown = articles[`../docs/content/articles/${entry.slug}.md`];
  const [heading, description, ...blocks] = markdown
    .trim()
    .split(/\r?\n\s*\r?\n/);
  return {
    ...entry,
    title: heading.replace(/^# /, ''),
    description,
    blocks,
    href: `/guides/${entry.slug}/`
  };
});

export type Guide = (typeof guides)[number];
